import { ImageFromServer } from '@/components/images//ImageFromServer';
import { Card, Grid, IconButton, Stack, Typography } from '@mui/material';
import { ExerciseDTO } from '@/generated';
import { Add } from '@mui/icons-material';

interface ExerciseProps {
  exercise: ExerciseDTO;
  onClick?: () => void;
  onAddClick?: () => void;
}

export const DrawerExercise = (props: ExerciseProps) => {
  return (
    <>
      <Card sx={{ mx: 1, mt: 0.75, p: 1 }}>
        <Grid onClick={props.onClick} sx={{ mt: 0.5 }} container size={12}>
          <Grid size={7} sx={{ overflowWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', alignContent: 'center', justifyItems: 'center' }}>
            <Stack direction={'row'} sx={{ alignItems: 'center', ml: 1, mr: 'auto' }}>
              <IconButton onClick={props.onAddClick}>
                <Add />
              </IconButton>
              <Typography sx={{ overflowWrap: 'break-word', textOverflow: 'ellipsis' }}>{props.exercise.name}</Typography>
            </Stack>
          </Grid>
          <Grid size={5} sx={{ display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center', justifyItems: 'center' }}>
            <ImageFromServer sx={{ height: '6rem', width: '6rem' }} thumbnail={false} fluid={true} alt="" id={props.exercise.imageId} />
          </Grid>
        </Grid>
      </Card>
    </>
  );
};
